var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["BUTTON"] = "button";
    ButtonTypes["RESET"] = "reset";
    ButtonTypes["SUBMIT"] = "submit";
})(ButtonTypes || (ButtonTypes = {}));
var ButtonStyleTypes;
(function (ButtonStyleTypes) {
    ButtonStyleTypes["LIGHT"] = "light";
    ButtonStyleTypes["DARK"] = "dark";
    ButtonStyleTypes["OUTLINED_LIGHT"] = "outlined-light";
    ButtonStyleTypes["OUTLINED_DARK"] = "outlined-dark";
})(ButtonStyleTypes || (ButtonStyleTypes = {}));
var ButtonSizes;
(function (ButtonSizes) {
    ButtonSizes["SMALL"] = "small";
    ButtonSizes["REGULAR"] = "regular";
    ButtonSizes["LARGE"] = "large";
    ButtonSizes["FULLWIDTH"] = "fullWidth";
})(ButtonSizes || (ButtonSizes = {}));

export { ButtonSizes, ButtonStyleTypes, ButtonTypes };
